import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 * apply/remove ws10-is-hidden to chosen block
 * visible -> true = hide element, false = show element
 */
export const showOrHideBlock = (blockId: string, visible?: boolean) => {
    document.getElementById(blockId)?.classList.toggle(CLASSNAME_HIDDEN, visible && visible);
};
